import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, TextField, Button, Snackbar, Alert, Grid } from "@mui/material";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";

import apiClient, { useApiQuery } from "../api/client";

const AdminSettings = () => {
  const { data, isLoading, refetch } = useApiQuery("/settings");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [whatsappMessage, setWhatsappMessage] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [toast, setToast] = useState("");

  useEffect(() => {
    if (data) {
      setWhatsappNumber(data.whatsappNumber || "");
      setPhoneNumber(data.phoneNumber || "");
      setWhatsappMessage(data.whatsappMessage || "");
    }
  }, [data]);

  const save = async () => {
    setIsSaving(true);
    try {
      await apiClient.put("/settings", { whatsappNumber, phoneNumber, whatsappMessage });
      setToast("Settings saved.");
      refetch();
    } catch (err) {
      setToast(err?.response?.data?.message || "Failed to save settings.");
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <Typography>Loading…</Typography>;

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Contact details shown across the public site.
      </Typography>

      <Paper sx={{ p: 3, maxWidth: 560 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="WhatsApp Number"
              placeholder="+923001234567"
              helperText="Include country code, e.g. +923001234567. Used for all WhatsApp buttons on the site."
              value={whatsappNumber}
              onChange={(e) => setWhatsappNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Phone Number (displayed)"
              placeholder="0322-7401538"
              helperText="Shown in the Contact section as the office phone number."
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              minRows={2}
              label="Default WhatsApp Message"
              value={whatsappMessage}
              onChange={(e) => setWhatsappMessage(e.target.value)}
            />
          </Grid>
        </Grid>

        <Button
          sx={{ mt: 3 }}
          variant="contained"
          startIcon={<SaveRoundedIcon />}
          onClick={save}
          disabled={isSaving}
        >
          {isSaving ? "Saving…" : "Save Settings"}
        </Button>
      </Paper>

      <Snackbar open={!!toast} autoHideDuration={3000} onClose={() => setToast("")}>
        <Alert severity="success" onClose={() => setToast("")}>
          {toast}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AdminSettings;
